/**
 * Oznaka magacinskog dokumenta u štampi i Excelu (narudžbenica, zahtev za ponudu, ulaz, izlaz, otpis, povrat, ponuda,
 * faktura, popis): upisani broj dokumenta, a kad ga niko nije upisao, interni ID sačuvanog dokumenta sa prefiksom "#"
 * (npr. "#223"), da se vidi da to nije redni broj iz numeracije. Dokument koji još nije sačuvan nema oznaku (prazan
 * tekst). Čim server počne sam da dodeljuje `number`, on ima prednost i u štampi se ništa ne menja.
 */
export const documentMark = (doc) => {
  const number = doc && doc.number != null ? String(doc.number).trim() : "";
  if (number) return number;
  return doc && doc.id ? `#${doc.id}` : "";
};

/** Naslov dokumenta, npr. "Narudžbenica 12/2026" ili "Narudžbenica #223"; bez oznake samo naziv. */
export const documentTitle = (label, doc) => [label, documentMark(doc)].filter(Boolean).join(" ");
